// Eigene Strich-Symbole der Telefonie (24er Raster, keine fremden Icon-Sätze).
import type { SVGProps } from "react";

export type SymbolName =
  | "telefon"
  | "auflegen"
  | "mikro"
  | "mikro-aus"
  | "tasten"
  | "handy"
  | "einstellungen"
  | "dialer"
  | "zu"
  | "warnung"
  | "neu"
  | "lautsprecher"
  | "pause"
  | "weiter";

const PFADE: Record<SymbolName, string> = {
  telefon: "M5 4h3l2 5-2 1a11 11 0 006 6l1-2 5 2v3a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z",
  auflegen: "M3 14c4-4 14-4 18 0l-2 3-4-1v-3a10 10 0 00-6 0v3l-4 1z",
  mikro: "M12 3a3 3 0 00-3 3v6a3 3 0 006 0V6a3 3 0 00-3-3zM5 11a7 7 0 0014 0M12 18v3",
  "mikro-aus": "M12 3a3 3 0 00-3 3v6a3 3 0 006 0V6a3 3 0 00-3-3zM5 11a7 7 0 0014 0M12 18v3M4 4l16 16",
  tasten: "M6 5h.01M12 5h.01M18 5h.01M6 11h.01M12 11h.01M18 11h.01M6 17h.01M12 17h.01M18 17h.01",
  handy: "M8 2h8a1 1 0 011 1v18a1 1 0 01-1 1H8a1 1 0 01-1-1V3a1 1 0 011-1zM11 18h2",
  einstellungen: "M4 7h10M18 7h2M4 17h4M12 17h8M14 5v4M8 15v4",
  dialer: "M4 6h12M4 12h8M4 18h6M17 14l4 4-4 4",
  zu: "M6 6l12 12M18 6L6 18",
  warnung: "M12 3l10 18H2zM12 10v5M12 18h.01",
  neu: "M20 12a8 8 0 11-2.3-5.7M20 4v5h-5",
  lautsprecher: "M4 9h4l5-4v14l-5-4H4zM16 9a4 4 0 010 6M18.5 6.5a8 8 0 010 11",
  pause: "M8 5v14M16 5v14",
  weiter: "M6 5l10 7-10 7zM18 5v14",
};

interface Props extends SVGProps<SVGSVGElement> {
  name: SymbolName;
  groesse?: number;
}

export function Symbol({ name, groesse = 18, ...rest }: Props) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={name === "tasten" ? 3 : 1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={PFADE[name]} />
    </svg>
  );
}
